import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({ providedIn: 'root' })
export class FingerprintService {
    private fpPromise: Promise<any> | null = null;

    async getFingerPrint(): Promise<string> {
        try {
            if (!this.fpPromise) {
                this.fpPromise = FingerprintJS.load();
            }
            const fp = await this.fpPromise;
            const fingerPrint = await fp.get();
            return fingerPrint.visitorId;
        } catch (error) {
            console.error('FP.JS ERROR', error);
            return '';
        }
    }
}
